module.exports = __webpack_public_path__ + "img/teacher-f3.fed61fb1.png";